'use client';

import { PlatformBridgeBase } from './base';

export class PlatformBridgeVoid extends PlatformBridgeBase {
    constructor() {
        super();
    }
}
